module.exports = __webpack_public_path__ + "img/1557614107229757442.f347fe53.png";